import * as React from "react";

import { Link } from "react-router-dom";

export default class Sidebar extends React.Component {
  render() {
    return (
      <div id="db-left-tab-bar-menu">
        <div className="main-icon-menu">
          {" "}
          <a href="#" className="logo d-block text-center">
            Logo
          </a>
          <div className="menu-body slimscroll">
            <nav className="nav">
              {" "}
              <a
                href="#"
                className="nav-link"
                data-toggle="tooltip-custom"
                data-placement="right"
                title=""
                data-original-title="Preview my site"
                data-trigger="hover"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.66667 5V12.5C1.66667 13.8807 2.78595 15 4.16667 15L15.8333 15C17.214 15 18.3333 13.8807 18.3333 12.5V5C18.3333 3.61929 17.214 2.5 15.8333 2.5H4.16667C2.78596 2.5 1.66667 3.61929 1.66667 5ZM4.16667 13.3333C3.70643 13.3333 3.33333 12.9602 3.33333 12.5L3.33333 5C3.33333 4.53976 3.70643 4.16667 4.16667 4.16667L15.8333 4.16667C16.2936 4.16667 16.6667 4.53976 16.6667 5V12.5C16.6667 12.9602 16.2936 13.3333 15.8333 13.3333L4.16667 13.3333ZM5 15.8333C4.53976 15.8333 4.16667 16.2064 4.16667 16.6667C4.16667 17.1269 4.53976 17.5 5 17.5H15C15.4602 17.5 15.8333 17.1269 15.8333 16.6667C15.8333 16.2064 15.4602 15.8333 15 15.8333H5Z"
                    fill="white"
                  />
                </svg>
              </a>{" "}
              <a
                href="#"
                className="nav-link"
                data-toggle="tooltip-custom"
                data-placement="right"
                title=""
                data-original-title="Products"
                data-trigger="hover"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.2634 3.47637C10.0924 3.41601 9.90742 3.41601 9.73637 3.47637L5.13519 5.10009L9.99989 6.8168L14.8646 5.10009L10.2634 3.47637ZM3.33331 13.3489V6.3241L9.16657 8.3826V16.0936L3.33331 13.3489ZM10.8332 16.0936L16.6665 13.3489V6.3241L10.8332 8.3826V16.0936ZM18.3331 13.9223V5.12068C18.3347 5.04737 18.3277 4.97292 18.3112 4.89887C18.3006 4.8511 18.2864 4.80465 18.2687 4.75993C18.2067 4.60241 18.1055 4.47288 17.9813 4.37995C17.9316 4.34273 17.8776 4.31096 17.82 4.28561C17.7984 4.27607 17.7764 4.26749 17.7541 4.25989L10.7904 1.80248C10.2773 1.62139 9.72249 1.62139 9.20933 1.80248L2.23647 4.26315C1.89619 4.38323 1.66667 4.72036 1.66667 5.10009V13.9223C1.66667 14.2709 1.86061 14.5868 2.16154 14.7284L9.66144 18.2573C9.87691 18.3587 10.1229 18.3587 10.3383 18.2573L17.8382 14.7284C18.1392 14.5868 18.3331 14.2709 18.3331 13.9223Z"
                    fill="white"
                  />
                </svg>
              </a>{" "}
              <a
                href="#"
                className="nav-link"
                data-toggle="tooltip-custom"
                data-placement="right"
                title=""
                data-original-title="Sites"
                data-trigger="hover"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6024 1.66667 10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10ZM9.53455 3.34933C9.68832 3.33872 9.84353 3.33333 10 3.33333C10.1565 3.33333 10.3117 3.33872 10.4655 3.34933C10.4939 3.38543 10.5247 3.42524 10.5573 3.46875C10.7651 3.74587 11.0503 4.17227 11.338 4.74768C11.8422 5.75602 12.3571 7.22728 12.475 9.16667L7.52505 9.16667C7.64293 7.22728 8.15785 5.75602 8.66202 4.74768C8.94973 4.17227 9.23487 3.74587 9.44271 3.46875C9.47534 3.42524 9.50606 3.38543 9.53455 3.34933ZM5.85564 10.8333C5.97635 13.0684 6.56829 14.7916 7.17131 15.9977L7.1982 16.0511C5.15629 15.104 3.67428 13.1539 3.38491 10.8333H5.85564ZM5.85564 9.16667H3.38491C3.67428 6.84612 5.15629 4.89596 7.19819 3.94891L7.17131 4.00232C6.56829 5.20837 5.97635 6.93165 5.85564 9.16667ZM7.52505 10.8333L12.475 10.8333C12.3571 12.7727 11.8422 14.244 11.338 15.2523C11.0503 15.8277 10.7651 16.2541 10.5573 16.5313C10.5247 16.5748 10.4939 16.6146 10.4655 16.6507C10.3117 16.6613 10.1565 16.6667 10 16.6667C9.84353 16.6667 9.68832 16.6613 9.53455 16.6507C9.50606 16.6146 9.47534 16.5748 9.44271 16.5313C9.23487 16.2541 8.94973 15.8277 8.66202 15.2523C8.15785 14.244 7.64293 12.7727 7.52505 10.8333ZM14.1444 10.8333C14.0237 13.0684 13.4317 14.7916 12.8287 15.9977L12.8018 16.0511C14.8437 15.104 16.3257 13.1539 16.6151 10.8333H14.1444ZM16.6151 9.16667C16.3257 6.84612 14.8437 4.89596 12.8018 3.94891L12.8287 4.00232C13.4317 5.20837 14.0237 6.93165 14.1444 9.16667H16.6151Z"
                    fill="white"
                  />
                </svg>
              </a>{" "}
              <a
                href="#"
                className="nav-link"
                data-toggle="tooltip-custom"
                data-placement="right"
                title=""
                data-original-title="Purchases"
                data-trigger="hover"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.5 1.66667C2.03976 1.66667 1.66667 2.03976 1.66667 2.5C1.66667 2.96024 2.03976 3.33333 2.5 3.33333V2.5L2.50001 3.33333H2.50004H2.50018H2.50071H2.50281H2.50628H2.51109H2.52461H2.54313H2.66276H3.07292H3.43707L4.17398 8.86014L4.17636 8.87672L4.55486 11.337L3.41003 13.8175C3.29094 14.0755 3.31156 14.3764 3.46472 14.6158C3.61788 14.8552 3.88248 15 4.16667 15H7.5C6.57953 15 5.83333 15.7462 5.83333 16.6667C5.83333 17.5871 6.57953 18.3333 7.5 18.3333C8.42048 18.3333 9.16667 17.5871 9.16667 16.6667C9.16667 15.7462 8.42048 15 7.5 15H13.3333C12.4129 15 11.6667 15.7462 11.6667 16.6667C11.6667 17.5871 12.4129 18.3333 13.3333 18.3333C14.2538 18.3333 15 17.5871 15 16.6667C15 15.7462 14.2538 15 13.3333 15H15.4167C15.8769 15 16.25 14.6269 16.25 14.1667C16.25 13.7064 15.8769 13.3333 15.4167 13.3333H5.46909L5.85371 12.5H15C15.3587 12.5 15.6771 12.2705 15.7906 11.9302L18.2906 4.43019C18.3753 4.17607 18.3327 3.89672 18.176 3.67941C18.0194 3.4621 17.7679 3.33333 17.5 3.33333H5.11849L4.99269 2.38986C4.93749 1.97586 4.58434 1.66667 4.16667 1.66667H3.07292H2.66276H2.54313H2.51109H2.50281H2.50159H2.5011H2.50089H2.50071H2.5004H2.50028H2.50018H2.50004H2.50001L2.5 2.5V1.66667ZM5.34071 5L5.82492 8.63156L6.16365 10.8333H14.3994L16.3438 5H5.34071Z"
                    fill="white"
                  />
                </svg>
              </a>{" "}
              <a
                href="#"
                className="nav-link"
                data-toggle="tooltip-custom"
                data-placement="right"
                title=""
                data-original-title="Payments & Shipping"
                data-trigger="hover"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.4142 6.12521C17.5148 6.38203 18.3333 7.35247 18.3333 8.5104V15.0483C18.3333 16.4023 17.214 17.5 15.8333 17.5L4.16667 17.5C2.78596 17.5 1.66667 16.4023 1.66667 15.0483L1.66667 10.1449L1.66667 8.5104C1.66667 7.15636 2.78595 6.05869 4.16667 6.05869H4.56369L12.1006 2.71818C13.3588 2.16053 14.8397 2.70872 15.4083 3.9426L15.7944 4.7804L16.3307 5.94401L16.4142 6.12521ZM3.33333 10.9621L3.33333 15.0483C3.33333 15.4996 3.70643 15.8655 4.16667 15.8655L15.8333 15.8655C16.2936 15.8655 16.6667 15.4996 16.6667 15.0483V10.9621H3.33333ZM16.6667 9.32764H3.33333V8.5104C3.33333 8.05905 3.70643 7.69316 4.16667 7.69316L15.8333 7.69316C16.2936 7.69316 16.6667 8.05905 16.6667 8.5104V9.32764ZM14.5546 6.05869L14.2757 5.45354L13.8896 4.61574C13.7 4.20445 13.2064 4.02172 12.787 4.2076L8.61054 6.05869L14.5546 6.05869ZM4.16667 13.4138C4.16667 12.9625 4.53976 12.5966 5 12.5966H8.33333C8.79357 12.5966 9.16667 12.9625 9.16667 13.4138C9.16667 13.8652 8.79357 14.2311 8.33333 14.2311H5C4.53976 14.2311 4.16667 13.8652 4.16667 13.4138Z"
                    fill="white"
                  />
                </svg>
              </a>{" "}
              <a
                href="#"
                className="nav-link"
                data-toggle="tooltip-custom"
                data-placement="right"
                title=""
                data-original-title="Printable catalog"
                data-trigger="hover"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.60063 3.33333H14.3994C15.4754 3.33333 16.4308 4.02191 16.7711 5.04276L18.1623 9.21637C18.2756 9.55626 18.3333 9.91219 18.3333 10.2705V14.1667C18.3333 15.5474 17.214 16.6667 15.8333 16.6667H4.16667C2.78596 16.6667 1.66667 15.5474 1.66667 14.1667V10.2705C1.66667 9.91219 1.72443 9.55626 1.83772 9.21637L3.22892 5.04276C3.56921 4.02191 4.52456 3.33333 5.60063 3.33333ZM5.60063 5C5.24194 5 4.92349 5.22953 4.81006 5.56981L3.41886 9.74342C3.39091 9.82727 3.36972 9.91307 3.35543 10H7.5C7.95158 10 8.31927 10.3592 8.33294 10.8075L8.33303 10.8082C8.33414 10.8178 8.33757 10.8414 8.34658 10.8745C8.36457 10.9404 8.40295 11.0376 8.48587 11.139C8.62774 11.3124 9.04117 11.6667 10.2273 11.6667C11.4134 11.6667 11.8268 11.3124 11.9687 11.139C12.0516 11.0376 12.09 10.9404 12.108 10.8745C12.117 10.8414 12.1204 10.8178 12.1215 10.8082L12.1216 10.8075C12.1353 10.3592 12.503 10 12.9545 10H16.6446C16.6303 9.91307 16.6091 9.82727 16.5811 9.74342L15.1899 5.56981C15.0765 5.22952 14.7581 5 14.3994 5H5.60063ZM3.33333 14.1667V11.6667H6.86678C6.94329 11.8345 7.04926 12.0151 7.19595 12.1944C7.7359 12.8543 8.68611 13.3333 10.2273 13.3333C11.7684 13.3333 12.7187 12.8543 13.2586 12.1944C13.4053 12.0151 13.5113 11.8345 13.5878 11.6667H16.6667V14.1667C16.6667 14.6269 16.2936 15 15.8333 15H4.16667C3.70643 15 3.33333 14.6269 3.33333 14.1667ZM6.66667 6.66667C6.20643 6.66667 5.83333 7.03976 5.83333 7.5C5.83333 7.96024 6.20643 8.33333 6.66667 8.33333H13.3333C13.7936 8.33333 14.1667 7.96024 14.1667 7.5C14.1667 7.03976 13.7936 6.66667 13.3333 6.66667H6.66667Z"
                    fill="white"
                  />
                </svg>
              </a>{" "}
              <a
                href="#"
                className="nav-link"
                data-toggle="tooltip-custom"
                data-placement="right"
                title=""
                data-original-title="Customers"
                data-trigger="hover"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 10C8.61929 10 7.5 11.1193 7.5 12.5V13.4524V15.8333C7.5 16.2936 7.1269 16.6667 6.66667 16.6667C6.20643 16.6667 5.83333 16.2936 5.83333 15.8333V13.4524V12.5L5.83344 12.4704C5.69732 12.4899 5.55817 12.5 5.41667 12.5C5.32495 12.5 5.23423 12.4958 5.14468 12.4875C5.09769 12.4957 5.04935 12.5 5 12.5H4.64286C3.91963 12.5 3.33333 13.0863 3.33333 13.8095V15C3.33333 15.4602 2.96024 15.8333 2.5 15.8333C2.03976 15.8333 1.66667 15.4602 1.66667 15V13.8095C1.66667 12.7503 2.21997 11.8204 3.0533 11.2929C2.70522 10.8126 2.5 10.2219 2.5 9.58333C2.5 7.9725 3.80584 6.66667 5.41667 6.66667C5.86878 6.66667 6.29687 6.76954 6.67881 6.95315C6.67077 6.85872 6.66667 6.76317 6.66667 6.66667C6.66667 4.82572 8.15905 3.33333 10 3.33333C11.8409 3.33333 13.3333 4.82572 13.3333 6.66667C13.3333 6.76317 13.3292 6.85872 13.3212 6.95315C13.7031 6.76954 14.1312 6.66667 14.5833 6.66667C16.1942 6.66667 17.5 7.9725 17.5 9.58333C17.5 10.2219 17.2948 10.8126 16.9467 11.2929C17.78 11.8204 18.3333 12.7503 18.3333 13.8095V15C18.3333 15.4602 17.9602 15.8333 17.5 15.8333C17.0398 15.8333 16.6667 15.4602 16.6667 15V13.8095C16.6667 13.0863 16.0804 12.5 15.3571 12.5H15C14.9507 12.5 14.9023 12.4957 14.8553 12.4875C14.7658 12.4958 14.675 12.5 14.5833 12.5C14.4418 12.5 14.3027 12.4899 14.1666 12.4704L14.1667 12.5V13.4524V15.8333C14.1667 16.2936 13.7936 16.6667 13.3333 16.6667C12.8731 16.6667 12.5 16.2936 12.5 15.8333V13.4524V12.5C12.5 11.1193 11.3807 10 10 10ZM10 8.33333C9.07953 8.33333 8.33333 7.58714 8.33333 6.66667C8.33333 5.74619 9.07953 5 10 5C10.9205 5 11.6667 5.74619 11.6667 6.66667C11.6667 7.58714 10.9205 8.33333 10 8.33333ZM5.41667 8.33333C4.72631 8.33333 4.16667 8.89298 4.16667 9.58333C4.16667 10.2737 4.72631 10.8333 5.41667 10.8333C6.10702 10.8333 6.66667 10.2737 6.66667 9.58333C6.66667 8.89298 6.10702 8.33333 5.41667 8.33333ZM14.5833 8.33333C13.893 8.33333 13.3333 8.89298 13.3333 9.58333C13.3333 10.2737 13.893 10.8333 14.5833 10.8333C15.2737 10.8333 15.8333 10.2737 15.8333 9.58333C15.8333 8.89298 15.2737 8.33333 14.5833 8.33333Z"
                    fill="white"
                  />
                </svg>
              </a>{" "}
              <a
                href="#"
                className="nav-link"
                data-toggle="tooltip-custom"
                data-placement="right"
                title=""
                data-original-title="Analytics"
                data-trigger="hover"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.3333 1.66667C12.4129 1.66667 11.6667 2.41286 11.6667 3.33333V5.83333H8.33333C7.41286 5.83333 6.66667 6.57953 6.66667 7.5V10H3.33333C2.41286 10 1.66667 10.7462 1.66667 11.6667V16.6667C1.66667 17.5871 2.41286 18.3333 3.33333 18.3333H7.5H12.5H16.6667C17.5871 18.3333 18.3333 17.5871 18.3333 16.6667V3.33333C18.3333 2.41286 17.5871 1.66667 16.6667 1.66667H13.3333ZM11.6667 16.6667V7.5H8.33333V11.6667V16.6667H11.6667ZM13.3333 16.6667H16.6667V3.33333H13.3333V7.5V16.6667ZM6.66667 11.6667V16.6667H3.33333V11.6667H6.66667Z"
                    fill="white"
                  />
                </svg>
              </a>{" "}
              <a
                href="#"
                className="nav-link"
                data-toggle="tooltip-custom"
                data-placement="right"
                title=""
                data-original-title="Users"
                data-trigger="hover"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.33333 4.16667C3.33333 3.70643 3.70643 3.33333 4.16667 3.33333H15.8333C16.2936 3.33333 16.6667 3.70643 16.6667 4.16667V15.8333C16.6667 16.2936 16.2936 16.6667 15.8333 16.6667L15 16.6667C15 14.3655 13.1345 12.5 10.8333 12.5H9.16667C6.86548 12.5 5 14.3655 5 16.6667L4.16667 16.6667C3.70643 16.6667 3.33333 16.2936 3.33333 15.8333V4.16667ZM6.66667 16.6667H13.3333C13.3333 15.286 12.214 14.1667 10.8333 14.1667H9.16667C7.78596 14.1667 6.66667 15.286 6.66667 16.6667ZM4.16667 1.66667C2.78596 1.66667 1.66667 2.78596 1.66667 4.16667V15.8333C1.66667 17.214 2.78596 18.3333 4.16667 18.3333H15.8333C17.214 18.3333 18.3333 17.214 18.3333 15.8333V4.16667C18.3333 2.78596 17.214 1.66667 15.8333 1.66667H4.16667ZM8.33333 8.33333C8.33333 9.25381 9.07953 10 10 10C10.9205 10 11.6667 9.25381 11.6667 8.33333C11.6667 7.41286 10.9205 6.66667 10 6.66667C9.07953 6.66667 8.33333 7.41286 8.33333 8.33333ZM10 5C8.15905 5 6.66667 6.49239 6.66667 8.33333C6.66667 10.1743 8.15905 11.6667 10 11.6667C11.841 11.6667 13.3333 10.1743 13.3333 8.33333C13.3333 6.49239 11.841 5 10 5Z"
                    fill="white"
                  />
                </svg>
              </a>{" "}
              <a
                href="#"
                className="nav-link"
                data-toggle="tooltip-custom"
                data-placement="right"
                title=""
                data-original-title="Email & Messaging"
                data-trigger="hover"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.83333 4.16667C5.83333 3.70643 6.20643 3.33333 6.66667 3.33333H9.72222H13.3333C13.7936 3.33333 14.1667 3.70643 14.1667 4.16667V5.83333V7.5V9.03687L10.5116 11.8797C10.2107 12.1137 9.78931 12.1137 9.48838 11.8797L5.83333 9.03688V7.5V5.83333V4.16667ZM4.16667 5.83333V4.16667C4.16667 2.78596 5.28595 1.66667 6.66667 1.66667H9.72222H13.3333C14.714 1.66667 15.8333 2.78595 15.8333 4.16667V5.83333C17.214 5.83333 18.3333 6.95262 18.3333 8.33333V15.8333C18.3333 17.214 17.214 18.3333 15.8333 18.3333H4.16667C2.78596 18.3333 1.66667 17.214 1.66667 15.8333V8.33333C1.66667 6.95262 2.78596 5.83333 4.16667 5.83333ZM15.8333 7.5V7.74058L16.0906 7.54047C16.0096 7.5142 15.9231 7.5 15.8333 7.5ZM4.16667 7.5C4.07688 7.5 3.99042 7.5142 3.90939 7.54047L4.16667 7.74058V7.5ZM3.33333 14.0541V9.20387L6.34384 11.5454L3.33333 14.0541ZM4.16667 16.6667C3.82472 16.6667 3.53087 16.4607 3.40242 16.1661L7.69044 12.5927L8.46515 13.1953C9.36793 13.8974 10.6321 13.8974 11.5349 13.1953L12.3096 12.5927L16.5976 16.1661C16.4691 16.4607 16.1753 16.6667 15.8333 16.6667H4.16667ZM16.6667 9.20387V14.0541L13.6562 11.5454L16.6667 9.20387ZM7.5 5.83333C7.5 5.3731 7.8731 5 8.33333 5H11.6667C12.1269 5 12.5 5.3731 12.5 5.83333C12.5 6.29357 12.1269 6.66667 11.6667 6.66667H8.33333C7.8731 6.66667 7.5 6.29357 7.5 5.83333ZM8.33333 7.5C7.8731 7.5 7.5 7.8731 7.5 8.33333C7.5 8.79357 7.8731 9.16667 8.33333 9.16667H11.6667C12.1269 9.16667 12.5 8.79357 12.5 8.33333C12.5 7.8731 12.1269 7.5 11.6667 7.5H8.33333Z"
                    fill="white"
                  />
                </svg>
              </a>{" "}
              <a
                href="#"
                className="nav-link"
                data-toggle="tooltip-custom"
                data-placement="right"
                title=""
                data-original-title="Audit Logs"
                data-trigger="hover"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.83333 2.5C5.83333 2.03976 6.20643 1.66667 6.66667 1.66667C7.1269 1.66667 7.5 2.03976 7.5 2.5V3.33333H12.5V2.5C12.5 2.03976 12.8731 1.66667 13.3333 1.66667C13.7936 1.66667 14.1667 2.03976 14.1667 2.5V3.33333H15C16.3807 3.33333 17.5 4.45262 17.5 5.83333V7.5V15.8333C17.5 17.214 16.3807 18.3333 15 18.3333H5C3.61929 18.3333 2.5 17.214 2.5 15.8333V7.5V5.83333C2.5 4.45262 3.61929 3.33333 5 3.33333H5.83333V2.5ZM6.66667 5H13.3333H15C15.4602 5 15.8333 5.3731 15.8333 5.83333V6.66667H4.16667V5.83333C4.16667 5.3731 4.53976 5 5 5H6.66667ZM4.16667 8.33333V15.8333C4.16667 16.2936 4.53976 16.6667 5 16.6667H15C15.4602 16.6667 15.8333 16.2936 15.8333 15.8333V8.33333L4.16667 8.33333ZM12.34 11.3243C12.6112 10.9524 12.5295 10.4312 12.1576 10.16C11.7858 9.88884 11.2645 9.97048 10.9933 10.3424L9.20884 12.7897L8.57004 11.9827C8.28437 11.6219 7.76026 11.561 7.39941 11.8466C7.03857 12.1323 6.97762 12.6564 7.2633 13.0173L8.58274 14.6839C8.7444 14.8881 8.99222 15.005 9.25261 14.9998C9.513 14.9947 9.75601 14.8681 9.90945 14.6576L12.34 11.3243Z"
                    fill="white"
                  />
                </svg>
              </a>{" "}
              <a
                href="#"
                className="nav-link"
                data-toggle="tooltip-custom"
                data-placement="right"
                title=""
                data-original-title="Marketing & Loyalty"
                data-trigger="hover"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.8083 2.70911C16.338 3.00287 16.6667 3.56092 16.6667 4.16667V7.22559C17.6377 7.56879 18.3333 8.49482 18.3333 9.58333C18.3333 10.6718 17.6377 11.5979 16.6667 11.9411V15C16.6667 15.6057 16.338 16.1638 15.8083 16.4576C15.2785 16.7513 14.6311 16.7345 14.1173 16.4137L12.4784 15.3904C11.1983 14.5911 9.79506 14.0246 8.33333 13.7092V16.6667C8.33333 17.1269 7.96024 17.5 7.5 17.5H5C4.53976 17.5 4.16667 17.1269 4.16667 16.6667V13.1784C2.7069 12.6368 1.66667 11.2316 1.66667 9.58333C1.66667 7.46624 3.38291 5.75 5.5 5.75H5.59055C8.02602 5.75 10.4126 5.06612 12.4784 3.77624L14.1173 2.75295C14.6311 2.43213 15.2785 2.41535 15.8083 2.70911ZM5.83333 13.4189V15.8333H6.66667V13.4613C6.38992 13.4383 6.11201 13.4241 5.83333 13.4189ZM15 4.16667L13.3611 5.18996L13.3333 5.20726C11.0091 6.65126 8.32723 7.41667 5.59055 7.41667H5.5C4.30338 7.41667 3.33333 8.38672 3.33333 9.58333C3.33333 10.7799 4.30338 11.75 5.5 11.75H5.59055C8.32723 11.75 11.0091 12.5154 13.3333 13.9594L13.3611 13.9767L15 15V13.0351V6.13154V4.16667Z"
                    fill="white"
                  />
                </svg>
              </a>{" "}
              <a
                href="#"
                className="nav-link"
                data-toggle="tooltip-custom"
                data-placement="right"
                title=""
                data-original-title="Notifications"
                data-trigger="hover"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 1.66667C9.07953 1.66667 8.33333 2.41286 8.33333 3.33333V3.61784C6.39135 4.30424 5 6.1563 5 8.33333L5 9.58333L5 11.333L3.65211 13.1864C3.2834 13.6934 3.23035 14.3643 3.51481 14.923C3.79927 15.4816 4.37313 15.8333 5 15.8333H7.5C7.5 17.214 8.61929 18.3333 10 18.3333C11.3807 18.3333 12.5 17.214 12.5 15.8333H15C15.6269 15.8333 16.2007 15.4816 16.4852 14.923C16.7697 14.3643 16.7166 13.6934 16.3479 13.1864L15 11.333L15 9.58333V8.33333C15 6.1563 13.6087 4.30424 11.6667 3.61784V3.33333C11.6667 2.41286 10.9205 1.66667 10 1.66667ZM10.8343 14.1667H10.8333H9.16667L7.06083 14.1667H5L6.21212 12.5L6.34789 12.3133C6.55507 12.0284 6.66667 11.6853 6.66667 11.333V9.58333V8.33333C6.66667 6.49238 8.15905 5 10 5C11.8409 5 13.3333 6.49238 13.3333 8.33333L13.3333 9.58333V11.333C13.3333 11.6853 13.4449 12.0284 13.6521 12.3133L13.7879 12.5L15 14.1667H12.9392H10.8343ZM10 16.6667C9.53976 16.6667 9.16667 16.2936 9.16667 15.8333H10.8333C10.8333 16.2936 10.4602 16.6667 10 16.6667ZM14.2263 3.02384C14.3972 2.59652 14.8822 2.38868 15.3095 2.5596L15 3.33333C15.3095 2.5596 15.31 2.55981 15.3106 2.56003L15.3117 2.56047L15.314 2.56141L15.3191 2.56352L15.3313 2.56861C15.3402 2.5724 15.3507 2.57701 15.3628 2.58249C15.3869 2.59343 15.4172 2.60784 15.4527 2.62611C15.5237 2.66262 15.6162 2.7148 15.7227 2.78579C15.9356 2.92773 16.2067 3.14631 16.4735 3.46651C17.0183 4.1202 17.5 5.14355 17.5 6.66667C17.5 7.1269 17.1269 7.5 16.6667 7.5C16.2064 7.5 15.8333 7.1269 15.8333 6.66667C15.8333 5.52312 15.4817 4.8798 15.1931 4.53349C15.0433 4.35369 14.8978 4.23894 14.7982 4.17254C14.7484 4.13937 14.7106 4.11863 14.6905 4.10826C14.6836 4.10471 14.6788 4.10241 14.6764 4.10128C14.2586 3.92542 14.0572 3.44644 14.2263 3.02384ZM4.69051 2.5596C5.11783 2.38868 5.6028 2.59652 5.77373 3.02384C5.94277 3.44644 5.74136 3.92542 5.32358 4.10128C5.32118 4.10241 5.31641 4.10471 5.30951 4.10826C5.28935 4.11863 5.25159 4.13937 5.20183 4.17254C5.10224 4.23894 4.95668 4.35369 4.80685 4.53349C4.51825 4.8798 4.16667 5.52312 4.16667 6.66667C4.16667 7.1269 3.79357 7.5 3.33333 7.5C2.8731 7.5 2.5 7.1269 2.5 6.66667C2.5 5.14355 2.98175 4.1202 3.52648 3.46651C3.79332 3.14631 4.06443 2.92773 4.27733 2.78579C4.38382 2.7148 4.47627 2.66262 4.54726 2.62611C4.58279 2.60784 4.61308 2.59343 4.63721 2.58249C4.64928 2.57701 4.65983 2.5724 4.66874 2.56861L4.68089 2.56352L4.68602 2.56141L4.68834 2.56047L4.68945 2.56003C4.68998 2.55981 4.69051 2.5596 5 3.33333L4.69051 2.5596Z"
                    fill="white"
                  />
                </svg>
              </a>{" "}
              <a
                href="#"
                className="nav-link"
                data-toggle="tooltip-custom"
                data-placement="right"
                title=""
                data-original-title="Social Media"
                data-trigger="hover"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 8.33333C14.3175 8.33333 13.683 8.12824 13.1546 7.77631L8.53001 10.0111L13.0096 12.3259C13.565 11.9118 14.2539 11.6667 15 11.6667C16.841 11.6667 18.3333 13.1591 18.3333 15C18.3333 16.841 16.841 18.3333 15 18.3333C13.1591 18.3333 11.6667 16.841 11.6667 15C11.6667 14.5211 11.7677 14.0658 11.9495 13.6542L7.93577 11.5801C7.37275 12.624 6.26921 13.3333 5 13.3333C3.15905 13.3333 1.66667 11.8409 1.66667 10C1.66667 8.15905 3.15905 6.66667 5 6.66667C6.27799 6.66667 7.388 7.38587 7.94737 8.44161L12.0113 6.47773C11.7907 6.03238 11.6667 5.53067 11.6667 5C11.6667 3.15905 13.1591 1.66667 15 1.66667C16.841 1.66667 18.3333 3.15905 18.3333 5C18.3333 6.84095 16.841 8.33333 15 8.33333ZM15 3.33333C14.0795 3.33333 13.3333 4.07953 13.3333 5C13.3333 5.92048 14.0795 6.66667 15 6.66667C15.9205 6.66667 16.6667 5.92048 16.6667 5C16.6667 4.07953 15.9205 3.33333 15 3.33333ZM5 8.33333C4.07953 8.33333 3.33333 9.07953 3.33333 10C3.33333 10.9205 4.07953 11.6667 5 11.6667C5.92048 11.6667 6.66667 10.9205 6.66667 10C6.66667 9.07953 5.92048 8.33333 5 8.33333ZM13.3333 15C13.3333 14.0795 14.0795 13.3333 15 13.3333C15.9205 13.3333 16.6667 14.0795 16.6667 15C16.6667 15.9205 15.9205 16.6667 15 16.6667C14.0795 16.6667 13.3333 15.9205 13.3333 15Z"
                    fill="white"
                  />
                </svg>
              </a>{" "}
              <a
                href="#"
                className="nav-link"
                data-toggle="tooltip-custom"
                data-placement="right"
                title=""
                data-original-title="Help"
                data-trigger="hover"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.8333 1.66667H4.16667C2.78596 1.66667 1.66667 2.78596 1.66667 4.16667V15.8333C1.66667 17.214 2.78596 18.3333 4.16667 18.3333H15.8333C17.214 18.3333 18.3333 17.214 18.3333 15.8333V4.16667C18.3333 2.78596 17.214 1.66667 15.8333 1.66667ZM3.33333 4.16667C3.33333 3.70643 3.70643 3.33333 4.16667 3.33333H15.8333C16.2936 3.33333 16.6667 3.70643 16.6667 4.16667V15.8333C16.6667 16.2936 16.2936 16.6667 15.8333 16.6667H4.16667C3.70643 16.6667 3.33333 16.2936 3.33333 15.8333V4.16667ZM9.82633 11.46C10.1647 11.46 10.4097 11.1917 10.4563 10.8883L10.4913 10.6783C11.763 10.4217 12.7897 9.815 12.7897 8.33333V8.31C12.7897 6.75833 11.6463 5.895 9.96633 5.895C8.93966 5.895 8.158 6.22167 7.53966 6.735C7.32966 6.91 7.23633 7.14333 7.23633 7.365C7.23633 7.80833 7.60966 8.18167 8.053 8.18167C8.25133 8.18167 8.438 8.1 8.578 7.995C8.998 7.68 9.42966 7.52833 9.93133 7.52833C10.608 7.52833 11.0047 7.83167 11.0047 8.35667V8.38C11.0047 8.95167 10.538 9.26667 9.523 9.395C9.14966 9.44167 8.928 9.71 8.98633 10.095L9.103 10.8883C9.14966 11.2033 9.39466 11.46 9.733 11.46H9.82633ZM8.718 13.2217V13.245C8.718 13.805 9.14966 14.2367 9.733 14.2367C10.3163 14.2367 10.748 13.805 10.748 13.245V13.2217C10.748 12.6617 10.3163 12.23 9.733 12.23C9.14966 12.23 8.718 12.6617 8.718 13.2217Z"
                    fill="white"
                  />
                </svg>
              </a>{" "}
            </nav>
          </div>
        </div>
        <div className="main-menu-inner">
          {" "}
          <a href="#" className="logo d-block text-center">
            Logo
          </a>
          <div className="topbar-left">
            <button className="button-menu-mobile nav-link text-right w-100">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="16" cy="16" r="16" fill="white" fillOpacity="0.1" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M20 9.33333H12C10.5272 9.33333 9.33333 10.5272 9.33333 12V20C9.33333 21.4728 10.5272 22.6667 12 22.6667H20C21.4728 22.6667 22.6667 21.4728 22.6667 20V12C22.6667 10.5272 21.4728 9.33333 20 9.33333ZM10.6667 12C10.6667 11.2636 11.2636 10.6667 12 10.6667H20C20.7364 10.6667 21.3333 11.2636 21.3333 12V20C21.3333 20.7364 20.7364 21.3333 20 21.3333H12C11.2636 21.3333 10.6667 20.7364 10.6667 20V12ZM16.1953 13.5286C16.4556 13.2682 16.8777 13.2682 17.1381 13.5286C17.3984 13.7889 17.3984 14.2111 17.1381 14.4714L15.6095 16L17.1381 17.5286C17.3984 17.7889 17.3984 18.2111 17.1381 18.4714C16.8777 18.7318 16.4556 18.7318 16.1953 18.4714L14.1953 16.4714C13.9349 16.2111 13.9349 15.7889 14.1953 15.5286L16.1953 13.5286Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
          <div className="menu-body slimscroll">
            <div className="main-icon-menu-pane">
              <ul className="nav metismenu">
                <li className="nav-item">
                  <div className="special-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.2634 3.47637C10.0924 3.41601 9.90742 3.41601 9.73637 3.47637L5.13519 5.10009L9.99989 6.8168L14.8646 5.10009L10.2634 3.47637ZM3.33331 13.3489V6.3241L9.16657 8.3826V16.0936L3.33331 13.3489ZM10.8332 16.0936L16.6665 13.3489V6.3241L10.8332 8.3826V16.0936ZM18.3331 13.9223V5.12068C18.3347 5.04737 18.3277 4.97292 18.3112 4.89887C18.3006 4.8511 18.2864 4.80465 18.2687 4.75993C18.2067 4.60241 18.1055 4.47288 17.9813 4.37995C17.9316 4.34273 17.8776 4.31096 17.82 4.28561C17.7984 4.27607 17.7764 4.26749 17.7541 4.25989L10.7904 1.80248C10.2773 1.62139 9.72249 1.62139 9.20933 1.80248L2.23647 4.26315C1.89619 4.38323 1.66667 4.72036 1.66667 5.10009V13.9223C1.66667 14.2709 1.86061 14.5868 2.16154 14.7284L9.66144 18.2573C9.87691 18.3587 10.1229 18.3587 10.3383 18.2573L17.8382 14.7284C18.1392 14.5868 18.3331 14.2709 18.3331 13.9223Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <a className="nav-link" href="/categories">
                    <span className="w-100">Categories</span>{" "}
                    <span className="menu-arrow">
                      <i className="mdi mdi-chevron-right"></i>
                    </span>{" "}
                  </a>
                  <ul className="nav-second-level" aria-expanded="false">
                    {/* <li>
                      <a href="#">Add a Category</a>
                    </li> */}
                    <li>
                      <a href="/categories">Categories List</a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <div className="special-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6024 1.66667 10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10ZM9.53455 3.34933C9.68832 3.33872 9.84353 3.33333 10 3.33333C10.1565 3.33333 10.3117 3.33872 10.4655 3.34933C10.4939 3.38543 10.5247 3.42524 10.5573 3.46875C10.7651 3.74587 11.0503 4.17227 11.338 4.74768C11.8422 5.75602 12.3571 7.22728 12.475 9.16667L7.52505 9.16667C7.64293 7.22728 8.15785 5.75602 8.66202 4.74768C8.94973 4.17227 9.23487 3.74587 9.44271 3.46875C9.47534 3.42524 9.50606 3.38543 9.53455 3.34933ZM5.85564 10.8333C5.97635 13.0684 6.56829 14.7916 7.17131 15.9977L7.1982 16.0511C5.15629 15.104 3.67428 13.1539 3.38491 10.8333H5.85564ZM5.85564 9.16667H3.38491C3.67428 6.84612 5.15629 4.89596 7.19819 3.94891L7.17131 4.00232C6.56829 5.20837 5.97635 6.93165 5.85564 9.16667ZM7.52505 10.8333L12.475 10.8333C12.3571 12.7727 11.8422 14.244 11.338 15.2523C11.0503 15.8277 10.7651 16.2541 10.5573 16.5313C10.5247 16.5748 10.4939 16.6146 10.4655 16.6507C10.3117 16.6613 10.1565 16.6667 10 16.6667C9.84353 16.6667 9.68832 16.6613 9.53455 16.6507C9.50606 16.6146 9.47534 16.5748 9.44271 16.5313C9.23487 16.2541 8.94973 15.8277 8.66202 15.2523C8.15785 14.244 7.64293 12.7727 7.52505 10.8333ZM14.1444 10.8333C14.0237 13.0684 13.4317 14.7916 12.8287 15.9977L12.8018 16.0511C14.8437 15.104 16.3257 13.1539 16.6151 10.8333H14.1444ZM16.6151 9.16667C16.3257 6.84612 14.8437 4.89596 12.8018 3.94891L12.8287 4.00232C13.4317 5.20837 14.0237 6.93165 14.1444 9.16667H16.6151Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <a className="nav-link" href="/products">
                    <span className="w-100">Products</span>{" "}
                    <span className="menu-arrow">
                      <i className="mdi mdi-chevron-right"></i>
                    </span>{" "}
                  </a>
                  <ul className="nav-second-level" aria-expanded="false">
                    <li>
                      <a href="/add-product">Add a Product</a>
                    </li>
                    <li>
                      <a href="/products">Products List</a>
                    </li>
                    <li>
                      <a href="/attributes">Attribute List</a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <div className="special-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.5 1.66667C2.03976 1.66667 1.66667 2.03976 1.66667 2.5C1.66667 2.96024 2.03976 3.33333 2.5 3.33333V2.5L2.50001 3.33333H2.50004H2.50018H2.50071H2.50281H2.50628H2.51109H2.52461H2.54313H2.66276H3.07292H3.43707L4.17398 8.86014L4.17636 8.87672L4.55486 11.337L3.41003 13.8175C3.29094 14.0755 3.31156 14.3764 3.46472 14.6158C3.61788 14.8552 3.88248 15 4.16667 15H7.5C6.57953 15 5.83333 15.7462 5.83333 16.6667C5.83333 17.5871 6.57953 18.3333 7.5 18.3333C8.42048 18.3333 9.16667 17.5871 9.16667 16.6667C9.16667 15.7462 8.42048 15 7.5 15H13.3333C12.4129 15 11.6667 15.7462 11.6667 16.6667C11.6667 17.5871 12.4129 18.3333 13.3333 18.3333C14.2538 18.3333 15 17.5871 15 16.6667C15 15.7462 14.2538 15 13.3333 15H15.4167C15.8769 15 16.25 14.6269 16.25 14.1667C16.25 13.7064 15.8769 13.3333 15.4167 13.3333H5.46909L5.85371 12.5H15C15.3587 12.5 15.6771 12.2705 15.7906 11.9302L18.2906 4.43019C18.3753 4.17607 18.3327 3.89672 18.176 3.67941C18.0194 3.4621 17.7679 3.33333 17.5 3.33333H5.11849L4.99269 2.38986C4.93749 1.97586 4.58434 1.66667 4.16667 1.66667H3.07292H2.66276H2.54313H2.51109H2.50281H2.50159H2.5011H2.50089H2.50071H2.5004H2.50028H2.50018H2.50004H2.50001L2.5 2.5V1.66667ZM5.34071 5L5.82492 8.63156L6.16365 10.8333H14.3994L16.3438 5H5.34071Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <a className="nav-link" href="">
                    <span className="w-100">Purchases</span>{" "}
                    <span className="menu-arrow">
                      <i className="mdi mdi-chevron-right"></i>
                    </span>{" "}
                  </a>
                  <ul className="nav-second-level" aria-expanded="false">
                    <li>
                      <a href="/trackOrder">Track Orders</a>
                    </li>
                    <li>
                      <a href="#">Abandoned Carts</a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <div className="special-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10 10C8.61929 10 7.5 11.1193 7.5 12.5V13.4524V15.8333C7.5 16.2936 7.1269 16.6667 6.66667 16.6667C6.20643 16.6667 5.83333 16.2936 5.83333 15.8333V13.4524V12.5L5.83344 12.4704C5.69732 12.4899 5.55817 12.5 5.41667 12.5C5.32495 12.5 5.23423 12.4958 5.14468 12.4875C5.09769 12.4957 5.04935 12.5 5 12.5H4.64286C3.91963 12.5 3.33333 13.0863 3.33333 13.8095V15C3.33333 15.4602 2.96024 15.8333 2.5 15.8333C2.03976 15.8333 1.66667 15.4602 1.66667 15V13.8095C1.66667 12.7503 2.21997 11.8204 3.0533 11.2929C2.70522 10.8126 2.5 10.2219 2.5 9.58333C2.5 7.9725 3.80584 6.66667 5.41667 6.66667C5.86878 6.66667 6.29687 6.76954 6.67881 6.95315C6.67077 6.85872 6.66667 6.76317 6.66667 6.66667C6.66667 4.82572 8.15905 3.33333 10 3.33333C11.8409 3.33333 13.3333 4.82572 13.3333 6.66667C13.3333 6.76317 13.3292 6.85872 13.3212 6.95315C13.7031 6.76954 14.1312 6.66667 14.5833 6.66667C16.1942 6.66667 17.5 7.9725 17.5 9.58333C17.5 10.2219 17.2948 10.8126 16.9467 11.2929C17.78 11.8204 18.3333 12.7503 18.3333 13.8095V15C18.3333 15.4602 17.9602 15.8333 17.5 15.8333C17.0398 15.8333 16.6667 15.4602 16.6667 15V13.8095C16.6667 13.0863 16.0804 12.5 15.3571 12.5H15C14.9507 12.5 14.9023 12.4957 14.8553 12.4875C14.7658 12.4958 14.675 12.5 14.5833 12.5C14.4418 12.5 14.3027 12.4899 14.1666 12.4704L14.1667 12.5V13.4524V15.8333C14.1667 16.2936 13.7936 16.6667 13.3333 16.6667C12.8731 16.6667 12.5 16.2936 12.5 15.8333V13.4524V12.5C12.5 11.1193 11.3807 10 10 10ZM10 8.33333C9.07953 8.33333 8.33333 7.58714 8.33333 6.66667C8.33333 5.74619 9.07953 5 10 5C10.9205 5 11.6667 5.74619 11.6667 6.66667C11.6667 7.58714 10.9205 8.33333 10 8.33333ZM5.41667 8.33333C4.72631 8.33333 4.16667 8.89298 4.16667 9.58333C4.16667 10.2737 4.72631 10.8333 5.41667 10.8333C6.10702 10.8333 6.66667 10.2737 6.66667 9.58333C6.66667 8.89298 6.10702 8.33333 5.41667 8.33333ZM14.5833 8.33333C13.893 8.33333 13.3333 8.89298 13.3333 9.58333C13.3333 10.2737 13.893 10.8333 14.5833 10.8333C15.2737 10.8333 15.8333 10.2737 15.8333 9.58333C15.8333 8.89298 15.2737 8.33333 14.5833 8.33333Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <a className="nav-link" href="">
                    <span className="w-100">Customers</span>{" "}
                    <span className="menu-arrow">
                      <i className="mdi mdi-chevron-right"></i>
                    </span>{" "}
                  </a>
                  <ul className="nav-second-level" aria-expanded="false">
                    <li>
                      <a href="#">Customers</a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
            <div className="special-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M3.33333 4.16667C3.33333 3.70643 3.70643 3.33333 4.16667 3.33333H15.8333C16.2936 3.33333 16.6667 3.70643 16.6667 4.16667V15.8333C16.6667 16.2936 16.2936 16.6667 15.8333 16.6667L15 16.6667C15 14.3655 13.1345 12.5 10.8333 12.5H9.16667C6.86548 12.5 5 14.3655 5 16.6667L4.16667 16.6667C3.70643 16.6667 3.33333 16.2936 3.33333 15.8333V4.16667ZM6.66667 16.6667H13.3333C13.3333 15.286 12.214 14.1667 10.8333 14.1667H9.16667C7.78596 14.1667 6.66667 15.286 6.66667 16.6667ZM4.16667 1.66667C2.78596 1.66667 1.66667 2.78596 1.66667 4.16667V15.8333C1.66667 17.214 2.78596 18.3333 4.16667 18.3333H15.8333C17.214 18.3333 18.3333 17.214 18.3333 15.8333V4.16667C18.3333 2.78596 17.214 1.66667 15.8333 1.66667H4.16667ZM8.33333 8.33333C8.33333 9.25381 9.07953 10 10 10C10.9205 10 11.6667 9.25381 11.6667 8.33333C11.6667 7.41286 10.9205 6.66667 10 6.66667C9.07953 6.66667 8.33333 7.41286 8.33333 8.33333ZM10 5C8.15905 5 6.66667 6.49239 6.66667 8.33333C6.66667 10.1743 8.15905 11.6667 10 11.6667C11.841 11.6667 13.3333 10.1743 13.3333 8.33333C13.3333 6.49239 11.841 5 10 5Z" fill="white"/>
              </svg>
            </div>
            <a className="nav-link" href="javascript:void(0);"><span className="w-100">Users</span> <span className="menu-arrow"><i className="mdi mdi-chevron-right"></i></span> </a>
            <ul className="nav-second-level" aria-expanded="false">
              <li><a href="/adminusers">Admin Users</a></li>
            </ul>
          </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
